<template>
  <div class="leading-normal tracking-normal bg-gray-100 " id="main-body">
    <LayoutNavbar />

    <div class="w-full flex flex-col sm:flex-row flex-wrap sm:flex-nowrap py-4 flex-grow ">
      <!-- fixed-width -->
      <div class="w-fixed pr-5 flex-shrink flex-grow-0 px-4">
        <div class="sticky top-0 pl-4 pt-1 h-full">
          <!-- nav goes here -->
          <LayoutAdminSidebar />
        </div>
      </div>
      <main role="main" class="w-full flex-grow pt-1 px-3 min-h-screen-75 h-full">
        <!-- fluid-width: main content goes here -->
        <NoticeBarComponent />
        <RouterView />
      </main>
    </div>
    <footer class="bg-black mt-auto text-white">
      <LayoutFooter />
    </footer>

  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useSidebarStore } from '../stores/sidebar'; // adjust the path to your store

import LayoutAdminSidebar from '@/components/LayoutAdminSidebar.vue'
import LayoutNavbar from '@/components/LayoutNavbar.vue'
import LayoutFooter from '@/components/LayoutFooter.vue'

export default defineComponent({
  name: 'DashboardLayout',
  components: {
    LayoutAdminSidebar,
    LayoutNavbar,
    LayoutFooter,
  },
  setup() {
    const store = useSidebarStore()
    const sideBarOpen = computed(() => store.sidebar)

    return {
      sideBarOpen
    };
  },
});
</script>